import "styles/global.css";
import routes, { renderRoutes } from "router";
import useAuth from "utils/hooks/useAuth";
import { LoadingScreen } from "fragment";
import { ToastContainer } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import InfoContext from "utils/context/info-context";
function App(): JSX.Element {
  const auth = useAuth();
  const info = useContext(InfoContext);
  return (
    <>
      {auth !== undefined && info !== null ? renderRoutes(routes) : <LoadingScreen />}
      <ToastContainer position="top-right" className="mt-32  md:mt-16" />
    </>
  );
}

export default App;
